import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import '@fontsource/open-sauce-one';
import { GlobalSnackbarProvider } from './context';
import { store } from './store';
import * as serviceWorker from './serviceWorker';
import './i18n';
import App from './App';

Sentry.init({
  // only log to Sentry if the environment is set (i.e. it's not local)
  dsn:
    !!process.env.REACT_APP_ENVIRONMENT && process.env.NODE_ENV !== 'development'
      ? process.env.REACT_APP_SENTRY_DSN
      : '',
  environment: process.env.REACT_APP_ENVIRONMENT || '',
  integrations: [new BrowserTracing()],
  tracesSampleRate: 1.0,
});

ReactDOM.render(
  <React.StrictMode>
    <GlobalSnackbarProvider>
      <Provider store={store}>
        <App />
      </Provider>
    </GlobalSnackbarProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
